import React, { useMemo } from "react";
import { Typography, Grid, List, theme, Tooltip } from "antd";
import { CheckOutlined } from "@ant-design/icons";

type FacilitiesListProps = {
  facilities?: string[];
};

const { Text } = Typography;

export const FacilitiesList: React.FC<FacilitiesListProps> = ({ facilities = [] }) => {
  // 1. เรียกใช้ Hook useToken เพื่อดึงค่าสีจาก Theme Config ของโปรเจกต์
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();

  const items = useMemo(
    () =>
      (facilities ?? [])
        .filter((x): x is string => typeof x === "string" && x.trim().length > 0)
        .map((facility) => ({
          facility,
        })),
    [facilities]
  );

  if (!items.length) {
    return null;
  }

  // Style สำหรับกล่องแต่ละรายการ (Minimalist Bordered Box)
  const itemStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: token.paddingSM, // ใช้ Token ระยะห่างมาตรฐาน
    padding: `${token.paddingSM}px ${token.padding}px`, // ปรับ Padding ให้ดูโปร่ง
    backgroundColor: token.colorBgContainer, // พื้นหลังตาม Theme (Dark mode ก็จะรอด)
    border: `1px solid ${token.colorBorderSecondary}`, // เส้นขอบสีจาง
    borderRadius: token.borderRadiusLG, // ความโค้งตาม Theme
    width: "100%",
    transition: "all 0.3s",
  };

  // Style สำหรับวงกลมรอบไอคอน
  const iconWrapperStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: "50%",
    // ใช้สีจาก Token เพื่อให้เปลี่ยนตาม Theme Editor
    backgroundColor: token.colorPrimaryBg, 
    color: token.colorPrimary,
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <List
        grid={{
          gutter: [16, 16], // เพิ่มระยะห่างแนวตั้งและแนวนอน
          column: screens.md ? 2 : 1,
        }}
        dataSource={items}
        renderItem={(item, index) => (
          <List.Item key={`${item.facility}-${index}`} style={{ marginBottom: 0, width: '100%' }}>
            <Tooltip trigger={["click"]} title={item.facility}>
              <div
                style={{...itemStyle, cursor: 'pointer'}}
                // (Optional) ถ้าอยากให้มี Hover Effect จางๆ สามารถเพิ่ม Logic onMouseEnter และ onMouseLeave ได้
              >
                <div style={iconWrapperStyle}>
                  <CheckOutlined style={{ fontSize: 14 }} />
                </div>
                <Text
                  strong
                  ellipsis
                  style={{
                    color: token.colorText, // สีตัวอักษรหลัก
                    fontSize: token.fontSize, // ขนาดฟอนต์มาตรฐาน
                  }}
                >
                  {item.facility}
                </Text>
              </div>
            </Tooltip>
          </List.Item>
        )}
      />
    </div>
  );
};